import React, { useCallback, useEffect, useRef, useState } from 'react'
import './EditCell.css';

export default function EditCell({children, switchMode, setLabel, carPos, editRef, path, saveMe, revertMe, editValidateMe, tabIx, isSensitive = false, getLastContent, ...rest}) {
  //console.log('[CellEdit Enter] [path: %s] [children: %s]', path, children);
  
  const inputRef = useRef(null);
  const [content, setContent] = useState(children || '');
  
  //------  Update Content  ------
  //
  const updateContent = useCallback((e) => {    
    const update = e.target.value;
    //console.log('[EditCell updateContent] [update: %s]', update);
    setContent(update);
    setLabel(update);
    editValidateMe(update);
  }, [setLabel, editValidateMe]);


  //------  Save  ------
  //
  const save = useCallback(() => {
    const lastContent = getLastContent();
    if (content !== lastContent) {
      // console.log('[EditCell save] [content: %s] [lastContent: %s]', content, lastContent);
      saveMe(path, content);      
    }    
    
    switchMode();
  }, [saveMe, switchMode, content, getLastContent, path]);


  //------  Pre RevertMe  ------
  //
  const preRevertMe = useCallback(() => {
    revertMe();
    switchMode();
  }, [revertMe, switchMode]);


  //------  Handle KeyDown  ------
  //
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      // console.log('[EditCell] Key: [Enter]');
      save();
    }
    else if (e.key === 'Escape') {
      // console.log('EditCell] Key: [Esc]');
      preRevertMe();
    }
  }, [save, preRevertMe]);


  //------  Effect carPos  ------
  //
  useEffect(()=>{
    if (inputRef.current) {
      inputRef.current.setSelectionRange(carPos, carPos);
    }
  }, [carPos]);

  useEffect(()=>{
    if (children) {
      setContent(children);
    }
  },[children]);
  
  return (      
      <input ref={inputRef} className='editCell' type='text' value={content}
             autoFocus={true} 
             onChange={updateContent} 
             onBlur={save}
             onKeyDown={handleKeyDown}
             tabIndex={tabIx}
             {...rest}/>
  )
}
